import { DIContainer } from "Global/Base/DIContainer";
import { ConsoleLogger } from "./ConsoleLogger";
import { ILogger } from "./ILogger";
import { ISectionLoggerFactory } from "./ISectionLoggerFactory";
import { SectionLoggerFactory } from "./SectionLoggerFactory";
import { ILoggingSettings } from "./types";

export const registerDefaultLogging = (loggingSettings: ILoggingSettings) => {
    DIContainer.instance.register(ILogger, ConsoleLogger, true);

    const loggerFactory = DIContainer.instance.createFactory(ILogger);
    DIContainer.instance.register(ISectionLoggerFactory, SectionLoggerFactory, true, loggingSettings, loggerFactory);
};
